import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { createUserStorage } from "../storage/user-storage";

interface DebugState {
  devToolsMounted: boolean;
  toggleDevTools: () => void;
}

export const useDebugStore = create<DebugState>()(
  persist(
    (set) => ({
      devToolsMounted: false,
      toggleDevTools: () => set((state) => ({ devToolsMounted: !state.devToolsMounted })),
    }),
    {
      name: "debug-store",
      storage: createJSONStorage(() => createUserStorage()),
    }
  )
);
